import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

/** 将 #hex 颜色转为 rgba 字符串 */
function hexToRgba(hex: string, alpha: number): string {
  const c = hex.replace("#", "");
  if (c.length < 6) return `rgba(255,255,255,${alpha})`;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

interface AutoCaptionProps {
  text: string;
  style: {
    theme: string;
    entrance: "wordHighlight";
    textStroke?: string;
    fontSize?: number;
    backgroundColor?: string;
    paddingBottom?: string;
  };
}

const AutoCaption: React.FC<AutoCaptionProps> = ({ text, style }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const words = text.split("");
  const wordDuration = 4; // 每个字高亮 4 帧
  const currentWordIndex = Math.min(
    Math.floor(frame / wordDuration),
    words.length - 1,
  );

  return (
    <AbsoluteFill
      style={{
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: style.backgroundColor || "transparent",
        paddingBottom: style.paddingBottom || "20%",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          maxWidth: "90%",
        }}
      >
        {words.map((char, i) => {
          const isCurrent = i === currentWordIndex;
          const isPast = i < currentWordIndex;
          void(i > currentWordIndex); // isFuture — unused but kept for readability

          // 当前字的弹性放大
          let scale = 1;
          if (isCurrent) {
            const localFrame = frame - i * wordDuration;
            const bounce = spring({
              frame: localFrame,
              fps,
              config: { damping: 8, mass: 0.5, stiffness: 200 },
              durationInFrames: wordDuration,
            });
            scale = interpolate(bounce, [0, 1], [1.3, 1.0]);
          }

          // 高亮颜色 — 基于 theme 计算透明度，适配任何颜色
          const color = isCurrent
            ? style.theme
            : isPast
              ? hexToRgba(style.theme, 0.6)
              : hexToRgba(style.theme, 0.3);

          // 当前字的发光
          const textShadow = isCurrent
            ? `0 0 30px ${style.theme}80, 0 0 60px ${style.theme}40`
            : "none";

          const fontSize = style.fontSize || 48;

          return (
            <span
              key={i}
              style={{
                fontSize,
                fontWeight: 700,
                fontFamily: "sans-serif",
                color,
                WebkitTextStroke: style.textStroke || "6px black",
                textShadow,
                transform: `scale(${scale})`,
                display: "inline-block",
                transition: "color 0.15s ease, text-shadow 0.15s ease",
              }}
            >
              {char === " " ? " " : char}
            </span>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

export default AutoCaption;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
